import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';

import {
  animate,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { toBoolean } from '../util/convert';

@Component({
  selector     : 'nz-badge',
  encapsulation: ViewEncapsulation.None,
  animations   : [
    trigger('enterLeave', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46)')
      ]),
      transition('* => void', [
        style({ opacity: 1 }),
        animate('0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46)')
      ])
    ])
  ],
  template     : `
    <ng-template *ngIf="content" [ngTemplateOutlet]="content"></ng-template>
    <span class="ant-badge-status-dot ant-badge-status-{{nzStatus}}" *ngIf="nzStatus"></span>
    <span class="ant-badge-status-text" *ngIf="nzText">{{ nzText }}</span>
    <sup [@enterLeave]
         [ngStyle]="nzStyle"
         *ngIf="(nzDot)||(nzCount>0)||((nzCount==0)&&nzShowZero)"
         data-show="true"
         class="ant-scroll-number"
         [class.ant-badge-count]="!nzDot"
         [class.ant-badge-dot]="nzDot">
      <ng-template ngFor
                   [ngForOf]="maxNumberArray"
                   let-number
                   let-i="index"><span *ngIf="nzCount<=nzOverflowCount"
                                       class="ant-scroll-number-only"
                                       [style.transform]="'translateY('+((-countArray[i]*100))+'%)'">
        <ng-template [ngIf]="(!nzDot)&&(countArray[i]!=null)">
          <p *ngFor="let p of countSingleArray" [class.current]="p==countArray[i]">{{ p }}</p>
        </ng-template>
        </span></ng-template>
      <ng-template [ngIf]="nzCount>nzOverflowCount">{{ nzOverflowCount }}+</ng-template>
    </sup>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-badge {
  position: relative;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
.ant-badge-count {
  position: absolute;
  transform: translateX(-50%);
  top: -10px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
  background: #f04134;
  color: #fff;
  line-height: 20px;
  text-align: center;
  padding: 0 6px;
  font-size: 14px;
  white-space: nowrap;
  transform-origin: -10% center;
  font-family: tahoma;
}
.ant-badge-count a,
.ant-badge-count a:hover {
  color: #fff;
}
.ant-badge-dot {
  position: absolute;
  transform: translateX(-50%);
  transform-origin: 0 center;
  top: -4px;
  height: 8px;
  width: 8px;
  border-radius: 100%;
  background: #f04134;
  z-index: 10;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.ant-badge-status-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
}
.ant-badge-status-success {
  background-color: #00a854;
}
.ant-badge-status-processing {
  background-color: #00b8a9;
  position: relative;
}
.ant-badge-status-processing:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #00b8a9;
  content: '';
  animation: antStatusProcessing 1.2s infinite ease-in-out;
}
.ant-badge-status-default {
  background-color: #d9d9d9;
}
.ant-badge-status-error {
  background-color: #f04134;
}
.ant-badge-status-warning {
  background-color: #ffbf00;
}
.ant-badge-status-text {
  color: #666;
  font-size: 14px;
  margin-left: 8px;
}
.ant-badge-zoom-appear,
.ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}
.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}
.ant-badge-not-a-wrapper .ant-badge-count {
  top: auto;
  display: block;
  position: relative;
  transform: none !important;
}
@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
}
.ant-scroll-number-only {
  display: inline-block;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  height: 20px;
}
.ant-scroll-number-only > p {
  height: 20px;
}
@keyframes antZoomBadgeIn {
  0% {
    opacity: 0;
    transform: scale(0) translateX(-50%);
  }
  100% {
    transform: scale(1) translateX(-50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translateX(-50%);
  }
  100% {
    opacity: 0;
    transform: scale(0) translateX(-50%);
  }
}
`,
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-badge {
  position: relative;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
.ant-badge-count {
  position: absolute;
  transform: translateX(-50%);
  top: -10px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
  background: #f04134;
  color: #fff;
  line-height: 20px;
  text-align: center;
  padding: 0 6px;
  font-size: 14px;
  white-space: nowrap;
  transform-origin: -10% center;
  font-family: tahoma;
}
.ant-badge-count a,
.ant-badge-count a:hover {
  color: #fff;
}
.ant-badge-dot {
  position: absolute;
  transform: translateX(-50%);
  transform-origin: 0 center;
  top: -4px;
  height: 8px;
  width: 8px;
  border-radius: 100%;
  background: #f04134;
  z-index: 10;
  box-shadow: 0 0 0 1px #fff;
}
.ant-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.ant-badge-status-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
}
.ant-badge-status-success {
  background-color: #00a854;
}
.ant-badge-status-processing {
  background-color: #00b8a9;
  position: relative;
}
.ant-badge-status-processing:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #00b8a9;
  content: '';
  animation: antStatusProcessing 1.2s infinite ease-in-out;
}
.ant-badge-status-default {
  background-color: #d9d9d9;
}
.ant-badge-status-error {
  background-color: #f04134;
}
.ant-badge-status-warning {
  background-color: #ffbf00;
}
.ant-badge-status-text {
  color: #666;
  font-size: 14px;
  margin-left: 8px;
}
.ant-badge-zoom-appear,
.ant-badge-zoom-enter {
  animation: antZoomBadgeIn 0.3s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  animation-fill-mode: both;
}
.ant-badge-zoom-leave {
  animation: antZoomBadgeOut 0.3s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  animation-fill-mode: both;
}
.ant-badge-not-a-wrapper .ant-badge-count {
  top: auto;
  display: block;
  position: relative;
  transform: none !important;
}
@keyframes antStatusProcessing {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}
.ant-scroll-number {
  overflow: hidden;
}
.ant-scroll-number-only {
  display: inline-block;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  height: 20px;
}
.ant-scroll-number-only > p {
  height: 20px;
}
@keyframes antZoomBadgeIn {
  0% {
    opacity: 0;
    transform: scale(0) translateX(-50%);
  }
  100% {
    transform: scale(1) translateX(-50%);
  }
}
@keyframes antZoomBadgeOut {
  0% {
    transform: scale(1) translateX(-50%);
  }
  100% {
    opacity: 0;
    transform: scale(0) translateX(-50%);
  }
}
.ant-badge-count {
  position: absolute;
  transform: translateX(50%);
  right: 0;
}
.ant-badge-dot {
  position: absolute;
  transform: translateX(50%);
  right: 0;
}
`
  ],
  host: {
    '[class.ant-badge]': 'true'
  }
})
export class NzBadgeComponent implements OnInit {
  private _showDot = false;
  private _showZero = false;
  count: number;
  maxNumberArray;
  countArray = [];
  countSingleArray = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ];
  @ContentChild('content') content: TemplateRef<void>;

  @HostBinding('class.ant-badge-not-a-wrapper')
  get setNoWrapper(): boolean {
    return !this.content;
  }

  @Input() nzOverflowCount = 99;

  @Input()
  set nzShowZero(value: boolean) {
    this._showZero = toBoolean(value);
  }

  get nzShowZero(): boolean {
    return this._showZero;
  }

  @Input()
  set nzDot(value: boolean) {
    this._showDot = toBoolean(value);
  }

  get nzDot(): boolean {
    return this._showDot;
  }

  @Input() nzText: string;
  @Input() nzStyle;
  @Input() @HostBinding('class.ant-badge-status') nzStatus: string;

  @Input()
  set nzCount(value: number) {
    if (value < 0) {
      this.count = 0;
    } else {
      this.count = value;
    }
    this.countArray = this.count.toString().split('');
  }

  get nzCount(): number {
    return this.count;
  }

  ngOnInit(): void {
    this.maxNumberArray = this.nzOverflowCount.toString().split('');
  }
}
